<template>
    <div class="px-6 surface-overlay relative">

        <ul class="list-none p-3 m-0 surface-card flex align-items-center font-medium overflow-x-auto">
            <li class="pr-3">
                <a @click="processLogin" class="cursor-pointer">
                    <i class="pi pi-home text-teal-500"></i>
                </a>
            </li>
            <li class="px-1">
                <i class="pi pi-angle-right text-500"></i>
            </li>
            <li class="px-1">
                <a @click="processLogin" class="cursor-pointer text-teal-500 white-space-nowrap">Login</a>
            </li>
        </ul>
    </div>
</template>

<script>

export default {

    methods: {
        processLogin() {
            console.log("[HeadingLogin][processLogin] Beginning.");
            window.location.href = "/#/login";
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
